import UtilLocalStorage from '@/utils/UtilLocalStorage.js';
export default class ServiceTableBase {
    static _localStorageTableResizeModeKey = 'tableResizeMode';
    static get _isTableResizeMode() {
        return UtilLocalStorage.isData(this._localStorageTableResizeModeKey);
    }
    static getTableResizeMode() {
        return this._isTableResizeMode ? UtilLocalStorage.getData(this._localStorageTableResizeModeKey) : 'minimize';
    }
    static setTableResizeMode(tableResizeMode = '') {
        UtilLocalStorage.setData(this._localStorageTableResizeModeKey, tableResizeMode);
    }
}